var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable } from "mobx";
import { ConsentFlowDocumentRetrievalLocation } from "healthex-common/screenshot.dtos";
import { NOT_LOADED } from "../Infra/RemoteData";
import { ProxyAccessDto } from "healthex-common/patient.dtos";
import { PatientDataVisualizationLiteDto } from "healthex-common/patient.data.visualization.dtos";
import { Exclude, Type } from "class-transformer";
export var PatientConsentSessionState;
(function (PatientConsentSessionState) {
    PatientConsentSessionState["INITIALIZED"] = "INITIALIZED";
    PatientConsentSessionState["RESTORING"] = "RESTORING";
    PatientConsentSessionState["RESTORING_COMPLETED"] = "RESTORING_COMPLETED";
})(PatientConsentSessionState || (PatientConsentSessionState = {}));
export class PatientConsentSession {
    constructor() {
        this.studyId = undefined;
        this._studyVersionId = undefined;
        this.studyPublicInfo = NOT_LOADED;
        this.study = NOT_LOADED;
        this.hasAuthorizedConsentEnrollment = null;
        this.patientInformedConsentEnabled = null;
        this.isInterested = null;
        this.isSubmittingConsent = false;
        this.hasConsentBeenSubmittedThisFlow = false;
        this.consentInfo = null;
        this.existingRetrieval = null;
        this.guidedConsentPatientMRN = null;
        this.guidedConsentLink = null;
        this.guidedConsentPatientSearchResult = NOT_LOADED;
        this.continueGuidedConsent = false;
        this.savedConsentedByLink = false;
        this.guidedConsentCloseRoute = null;
        this.patientSignatureHIPAA = null;
        this.patientSigningReasonHIPAA = null;
        this.providerSignature = null;
        this.parentGuardianSignature = null;
        this.parentGuardianSigningReason = null;
        this.additionalParentGuardianSignature = null;
        this.additionalParentGuardianSigningReason = null;
        this.minorParticipantSignature = null;
        this.witnessSignature = null;
        this.additionalParentGuardianExemptSignature = null;
        this.minorParticipantExemptFromAssent = null;
        this.larParticipantExemptSignature = null;
        this.witnessSkipSignature = null;
        this.parentGuardianProxyAccess = null;
        this.additionalParentGuardianProxyAccess = null;
        this.isAdditionalParentGuardianNameUnique = null;
        this.documentRetrievalLocations = [];
        this.retrievalBatchId = null;
        this.recordsSummary = null;
        this.contactMethod = null;
        this.contactEmail = null;
        this.contactPhone = null;
        this.currentInteractivePreviewRoute = null;
        this.routeBeforePopup = null;
        this.didEnterConsentFlow = false;
        this.didTryToRedirectToWelcomeBackPage = false;
        this.continueWhereILeftOffRoute = null;
        this.hasLoggedInDuringConsent = null;
        this.hasDeclinedBeforeLogin = null;
        this.interactivePreviewMetadata = null;
        this._consentFlowPageData = null;
        this.patientConsentSessionState = PatientConsentSessionState.INITIALIZED;
        this.patientCollectedEmail = null;
        this.userChoseToUpdateRecords = null;
        this.locationsNeedingAuthentication = [];
        this.selectedLoginType = null;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "studyId", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "_studyVersionId", void 0);
__decorate([
    Exclude(),
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "studyPublicInfo", void 0);
__decorate([
    Exclude(),
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "study", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "hasAuthorizedConsentEnrollment", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "patientInformedConsentEnabled", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "isInterested", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], PatientConsentSession.prototype, "isSubmittingConsent", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], PatientConsentSession.prototype, "hasConsentBeenSubmittedThisFlow", void 0);
__decorate([
    Exclude(),
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "consentInfo", void 0);
__decorate([
    Exclude(),
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "existingRetrieval", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "guidedConsentPatientMRN", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "guidedConsentLink", void 0);
__decorate([
    Exclude(),
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "guidedConsentPatientSearchResult", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "continueGuidedConsent", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], PatientConsentSession.prototype, "savedConsentedByLink", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "guidedConsentCloseRoute", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "patientSignatureHIPAA", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "patientSigningReasonHIPAA", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "providerSignature", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "parentGuardianSignature", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "parentGuardianSigningReason", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "additionalParentGuardianSignature", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "additionalParentGuardianSigningReason", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "minorParticipantSignature", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "witnessSignature", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "additionalParentGuardianExemptSignature", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "minorParticipantExemptFromAssent", void 0);
__decorate([
    Exclude(),
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "larParticipantExemptSignature", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "witnessSkipSignature", void 0);
__decorate([
    Type(() => ProxyAccessDto),
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "parentGuardianProxyAccess", void 0);
__decorate([
    Type(() => ProxyAccessDto),
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "additionalParentGuardianProxyAccess", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "isAdditionalParentGuardianNameUnique", void 0);
__decorate([
    Type(() => ConsentFlowDocumentRetrievalLocation),
    observable,
    __metadata("design:type", Array)
], PatientConsentSession.prototype, "documentRetrievalLocations", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "retrievalBatchId", void 0);
__decorate([
    Type(() => PatientDataVisualizationLiteDto),
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "recordsSummary", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "contactMethod", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "contactEmail", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "contactPhone", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "currentInteractivePreviewRoute", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "routeBeforePopup", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "didEnterConsentFlow", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "didTryToRedirectToWelcomeBackPage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "continueWhereILeftOffRoute", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "hasLoggedInDuringConsent", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "hasDeclinedBeforeLogin", void 0);
__decorate([
    Exclude(),
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "interactivePreviewMetadata", void 0);
__decorate([
    Exclude(),
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "_consentFlowPageData", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], PatientConsentSession.prototype, "patientConsentSessionState", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "patientCollectedEmail", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "userChoseToUpdateRecords", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], PatientConsentSession.prototype, "locationsNeedingAuthentication", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentSession.prototype, "selectedLoginType", void 0);
